<template>
    <div class="ak-panel ak-panel--no-padding m-b-xs-20">
        <div class="ak-panel__header ak-panel__header--small">
            <div class="ak-panel__title">
                <i class="fa fa-list"></i>
                {{ $t('Te behandelen kandidaat-partners') }}
            </div>
        </div>
        <div class="ak-panel__body ak-panel__body--small reading">
            <div class="ak-data-table__table table-candidates">
                <table v-if="candidates.length" class="ak-table ak-table--compact ak-panel__table">
                    <thead>
                        <tr class="ak-table-row ak-table">
                            <th class="ak-table-head table-head th-sticky">
                                <span>{{ $t('Datum aanvraag') }}</span>
                            </th>
                            <th class="ak-table-head th-sticky">
                                <span>{{ $t('Naam') }}</span>
                            </th>
                            <th class="ak-table-head th-sticky">
                                <span>{{ $t('Locatie') }}</span>
                            </th>
                        </tr>
                    </thead>
                    <tbody class="ak-table-body">
                        <tr v-for="(request, index) in candidates" :key="index" class="ak-table-row">
                            <td  v-if="request.status === 0" class="ak-table-column">
                                <span>{{ request.dateRequest | date }}</span>
                            </td>
                            <td  v-if="request.status === 0" class="ak-table-column">
                                <router-link :to="{ name: 'supplier-candidate-overview', params: { hashId: request.hashId }}" class="text-decoration-none">
                                    <span>{{ request.companyName }}</span>
                                </router-link>
                            </td>
                            <td  v-if="request.status === 0" class="ak-table-column">
                                <span>{{ request.location}}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div v-else>
                    {{ $t('Geen nieuwe aanvragen') }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CandidatePartners',
    data() {
        return {
            loading: false,
            candidates: null,
        }
    },
    methods: {
        async getAttests() {
            this.loading = true;
            const result = await this.$get(this.$getSetting('paths.baseCms') + '/candidates');
            if (result) {
                this.candidates = result.candidates;
            }

            this.loading = false;
        },
    },
    created() {
        this.getAttests();
    }
}
</script>
